module.exports = __webpack_public_path__ + "img/fashionphile.8005e1b1.svg";